<template>
    <transition appear name="slide">
        <div id="dyp-div" class="popup" v-show="isOpen">
            <button aria-label="Close dialog" @click="isOpen = false">✕</button>
            <p>Want to meet our team? See which events we'll be attending soon.</p>
            <router-link target="_blank" class="button button--white" to="/campus-resources/campus-events">
                <span>View Events</span>
            </router-link>
        </div>
    </transition>
</template>

<script>
export default {
    data: () => ({
        isOpen: false,
    }),

    mounted() {
        setTimeout(() => {
            this.isOpen = true
        }, 500)
    },
}
</script>